<div class="d-none d-lg-block">
  <fgb-banner title="Marketplace" class="mb-3"></fgb-banner>

  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
</div>

<div class="container my-5" *ngIf="marketplaceItem">
  <div [innerHTML]="marketplaceItem.TermsAndConditions"></div>
</div>
